import { useTranslation } from 'react-i18next';
import aBola from '@/assets/auth/trusted/a-bola.svg';
import eaton from '@/assets/auth/trusted/eaton.svg';
import mcSone from '@/assets/auth/trusted/mc-sone.png';
import musicalize from '@/assets/auth/trusted/musicalize.png';
import nba from '@/assets/auth/trusted/nba.svg';
import slam from '@/assets/auth/trusted/slam.svg';
import vivo from '@/assets/auth/trusted/vivo.png';

/**
 * The "Trusted by" strip under the auth card, scrolling continuously.
 *
 * Every file is white with a transparent ground — drawn for the dark theme — so
 * the light theme inverts them. There is no second colour in any of them to
 * lose that way.
 */
/**
 * Exported, and each entry named.
 *
 * The bundler turns every `src` into an opaque asset handle — a stub under
 * jest — so the file a logo came from is not something a test can read back.
 * Naming the entries gives the list a value that survives the build, which is
 * what pins WHICH brands are on the strip rather than merely how many.
 */
export const LOGOS = [
  { name: 'nba', src: nba, height: 15 },
  { name: 'a-bola', src: aBola, height: 12 },
  { name: 'eaton', src: eaton, height: 12 },
  { name: 'slam', src: slam, height: 13 },
  { name: 'vivo', src: vivo, height: 13 },
  { name: 'mc-sone', src: mcSone, height: 13 },
  { name: 'musicalize', src: musicalize, height: 12 },
];

/** Copies of the list inside the track. Must match the distance in the keyframe. */
const COPIES = [0, 1, 2];

export const TrustedBy = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full max-w-3xl flex-col items-center gap-2 sm:flex-row sm:gap-5">
      <span className="shrink-0 whitespace-nowrap text-[8px] leading-[10px] text-auth-body">
        {t('app.auth.trusted_by')}
      </span>

      {/* The mask fades both ends, so logos arrive and leave instead of being
          clipped against a hard edge. */}
      <div
        className="w-full overflow-hidden"
        style={{
          maskImage:
            'linear-gradient(to right, transparent, black 6%, black 94%, transparent)',
          WebkitMaskImage:
            'linear-gradient(to right, transparent, black 6%, black 94%, transparent)',
        }}
      >
        <div aria-hidden="true" className="flex w-max animate-auth-marquee items-center">
          {COPIES.map(copy => (
            <ul key={copy} className="flex shrink-0 items-center gap-5 pr-5">
              {LOGOS.map(({ name, src, height }) => (
                <li key={name} className="shrink-0">
                  <img
                    src={src}
                    alt=""
                    style={{ height }}
                    className="w-auto max-w-none opacity-80 invert dark:invert-0"
                  />
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
};
